import { phishingLanguageDisplayLabel } from '@/api/enums/phishing-languages.enum';
import { FiltersType } from '@/api/types';
import { client } from '@/client';
import { PartialRequestMultiselect } from '@/components/form/generic/PartialRequestMultiselect';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type PhishingLanguagesMultiselectInputProps = {
  onChange: (value: string[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: { id: string; value: string; name: string }[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange' | 'defaultChecked'>;

export const PhishingLanguagesMultiselectInput: React.FC<
  PhishingLanguagesMultiselectInputProps
> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
}) => {
  const { t } = useTranslation();

  const fetchLanguages = isDisabled
    ? undefined
    : async () => {
        const languages =
          await client.campaignTemplates.getCampaignTemplateLanguages();
        return languages
          .map((language: string) => ({
            id: language,
            value: language,
            name: phishingLanguageDisplayLabel[language],
          }))
          .filter((option) => option.name)
          .sort((a, b) => a.name.localeCompare(b.name));
      };

  return (
    <PartialRequestMultiselect
      dataKey="id"
      fetchService={fetchLanguages}
      filter
      display="chip"
      optionLabel="name"
      filterBy="name"
      placeholder={t('generic.select')}
      maxSelectedLabels={10}
      additionalFilters={additionalFilters}
      selectedOptions={selectedOptions?.filter((option) => option?.id !== null)}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      disabled={isDisabled}
      isNotListingResponse
    />
  );
};
